import { render, staticRenderFns } from "./newHomeFooter1.vue?vue&type=template&id=2451e163&scoped=true&"
import script from "./newHomeFooter1.vue?vue&type=script&lang=js&"
export * from "./newHomeFooter1.vue?vue&type=script&lang=js&"
import style0 from "./newHomeFooter1.vue?vue&type=style&index=0&id=2451e163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451e163",
  null
  
)

export default component.exports